import workingDocumentSlice from "./workingDocumentSlice";

export default workingDocumentSlice.reducer;
export { default as workingDocumentSlice, fetchWorkingDocuments } from "./workingDocumentSlice";
